import { FieldError, RegisterOptions } from 'react-hook-form';
import { Box, Flex, Select, Text } from '@chakra-ui/react';

interface IFormSelect {
  name: string;
  register: Function;
  options?: (string | number | boolean)[];
  labeledOptions?: { value: string | number; label: string }[];
  ph: string;
  onChange?: Function;
  isDisabled?: boolean;
  registerOptions?: RegisterOptions;
  error?: FieldError;
}

const FormSelect: React.FC<IFormSelect> = ({
  name,
  register,
  options = [],
  labeledOptions = [],
  ph,
  onChange = () => {},
  isDisabled = false,
  registerOptions = {},
  error,
}) => {
  return (
    <Box>
      <Flex>
        <Text w={'15rem'} mr={4}>
          {ph}:
        </Text>
        <Select
          {...register(name, registerOptions)}
          onChange={onChange}
          isDisabled={isDisabled}
          isInvalid={!!error}
        >
          {(!!labeledOptions.length &&
            labeledOptions.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))) ||
            (options.length &&
              options.map((option) => (
                <option value={option.toString()} key={option.toString()}>
                  {option.toString()}
                </option>
              ))) || <option value={''}>No available options</option>}
        </Select>
      </Flex>
      {error && (
        <Text color="red.500" fontSize="sm" ml="9.7rem" pl={4}>
          {error.message || 'Required field'}
        </Text>
      )}
    </Box>
  );
};

export default FormSelect;
